import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import colors from '../../styles/colors';
import fonts from '../../styles/fonts';

const buttonStyles = {
	amountBtn: {
		width: '86px',
		height: '45px',
		padding: 0,
		borderRadius: '5px',
		border: `1px solid ${colors.secondaryBlue}`,
		fontSize: '16px',
		fontFamily: fonts.ppSansBigRegular,
		textDecoration: 'none'
	},
	defaultColor: {
		backgroundColor: colors.secondaryBlue
	},
	highlightedColor: {
		backgroundColor: colors.primaryBlue
	}
}

const STYLES = StyleSheet.create({
	defaultBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.defaultColor
	},
	highlightedBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.highlightedColor
	}
});

class PresetAmountButton extends React.Component {
	
	handleClick(event, value) {
		this.props.handleAmountBtnClick(event, this.props.value)
	}

	render() {
		const { selected } = this.props;
		const btnClasses = classNames(
			'vx_btn', {
				[css(STYLES.highlightedBtn)]: selected,
				[css(STYLES.defaultBtn)]: !selected,
			});

		return (
			<button type="button"
				className={btnClasses}
				onClick={this.handleClick.bind(this)}
			>{this.props.symbol}{this.props.value}
			</button>
		);
	}
}

PresetAmountButton.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selected: PropTypes.bool,
	symbol: PropTypes.string,
	handleAmountBtnClick: PropTypes.func.isRequired
};

export default PresetAmountButton;



// WEBPACK FOOTER //
// ./components/amount/PresetAmountButton.js